import SingleSelectInput from "./inputs/SingleSelectInput";
import MultiSelectInput from "./inputs/MultiSelectInput";
import SliderInput from "./inputs/SliderInput";
import OpenTextInput from "./inputs/OpenTextInput";

/**
 * QuestionRenderer — type dispatcher.
 *
 * Future-extensibility hooks (Sprint C+):
 *  - voice-guided prompt: read `question.audio_url` if present (none yet).
 *  - i18n: wrap `question.prompt` via translator (none yet).
 *  - per-(door × readiness × intensity × source) variants come from the
 *    backend payload — no frontend change required when they ship.
 */
const REGISTRY = {
  "single-select": SingleSelectInput,
  "multi-select": MultiSelectInput,
  "slider": SliderInput,
  "open-text": OpenTextInput,
};

export default function QuestionRenderer({ question, value, onChange }) {
  const Input = REGISTRY[question.type];
  if (!Input) {
    return (
      <p className="text-sm text-slate-500 italic" data-testid={`q-${question.id}-unknown`}>
        (This question type isn't supported yet.)
      </p>
    );
  }
  return <Input question={question} value={value} onChange={onChange} />;
}
